import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/lumina.css';   // 루미나 틀 전역 스타일(시안 CSS 이식)
import App from './App';
import { startSessionGuard } from './utils/sessionGuard';
// [2026-09-27] 브라우저 기본 알림창 → 운영사 로고가 있는 사이트 알림창(규칙의 자리 utils/alertBridge.js)
import { installAlertBridge } from './utils/alertBridge';

// zoom 기능 제거됨 - 2025.08.21

/* [2026-09-07] 로그인 만료 예약·무활동 자동 로그아웃 감시를 앱 시작 때 1회 건다.
   두 번 불러도 한 번만 걸리며, 로그인 상태가 아니면 아무것도 하지 않는다(무손상).
   정본: ~/tosino/docs/SPEC_자동로그아웃_세션만료.md §3 */
// [2026-09-27] 사이트 알림 다리를 로그인 감시보다 먼저 건다 — 감시가 띄우는 무활동 로그아웃 안내도 같은 알림창으로 가게
installAlertBridge();
startSessionGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);